import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import {Modal} from "react-bootstrap";
import Delete from '../Delete/Delete.js';


const BrandIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const [BrandList, setBrandList] = useState([]);
    const [image, setImage] = useState({ preview: "", raw: "" });
    const [Id, setId] = useState(0);
    const [Title, setTitle] = useState('');
    const [IsActive, setIsActive] = useState(true);
    const [Web_IsActive, setWeb_IsActive] = useState(true);
    const [Order, setOrder] = useState(1);
    const [ShowModal, setShowModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion

    //#region Handlers

    const ImageChange = e => {
        if (e.target.files.length) {
            setImage({
                preview: URL.createObjectURL(e.target.files[0]),
                raw: e.target.files[0]
            });
        }
    };
    //#endregion  


    //#region Methods

    const GetAll = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/ProductBrand/GetAll', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'IsActive': -1,
                    'WebIsActive': -1
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result[i].id,
                            Title: result[i].title,
                            IsActive: result[i].isActive,
                            Web_IsActive: result[i].web_IsActive,
                            IdentityNo: result[i].identityNo,
                            Image: General.ApiPhotoRoute() + 'Content/Images/BrandPhoto/' + result[i].id + '.jpg',

                        })
                    }
                    setBrandList(tmp)
                })
        )
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };


    const Reset = () => {
        setTitle("");
        setId(0);
        setOrder(Order*1+1)
        setIsActive(true);
        setWeb_IsActive(true)
        setImage("", "");
    }

    const Save = () => {
        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        var f_data = new FormData();
        f_data.append("Id", Id);
        f_data.append("Title", Title);
        f_data.append("Order", Order);
        f_data.append("IsActive", IsActive ? 1 : 0);
        f_data.append("Web_IsActive", Web_IsActive ? 1 : 0);
        f_data.append("Image", image.raw);
        console.dir(image.raw);
        var RequestOptions = {
            method: "post",
            withCredentials: true,
            headers: {
                'ApiKey': General.APIKey(),
                'content-type': 'multipart/form-data'
            }

        }

        trackPromise(
            axios.post(General.ApiRoute() + "/ProductBrand/Save", f_data, RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        GetAll();
                        Reset();
                        setShowModal(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const ShowDelete = (id, title) => {
        DeleteRef.current.Get(5, id, title);
    }

    const ShowEdit = (Id) => {
        Reset();
        setId(Id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/ProductBrand/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    
                    setTitle(result.title);
                    setOrder(result.order);
                    setIsActive(result.isActive == 0 ? false : true);
                    setWeb_IsActive(result.web_IsActive == 0 ? false : true);
                    setImage({ preview: General.ApiPhotoRoute() + 'Content/Images/BrandPhoto/' + Id + '.jpg', row: "" })
                })
        )
    }

    const ShowNew = () => {
        setShowModal(true);
        Reset();
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 5);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        GetAll();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }



    useEffect(() => {
        CheckPermission();
        document.title = "برند محصولات ";
    }, [])
    //#endregion







    return (

        <Layout title="برند محصولات">


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={600}
                                    data={BrandList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}

                                >
                                    <rsuite.Table.Column flexGrow={1} align="center" sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={2} align="center"  >
                                        <rsuite.Table.HeaderCell>تصویر</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    <div
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            background: '#f5f5f5',
                                                            borderRadius: 6,
                                                            marginTop: 2,
                                                            overflow: 'hidden',
                                                            display: 'inline-block'
                                                        }}
                                                    >
                                                        <img src={rowData.Image} width="40" />
                                                    </div>
                                                </>


                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={4} sortable fixed resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Title" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} sortable resizable>
                                        <rsuite.Table.HeaderCell>شناسه </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="IdentityNo" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>فعال   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.IsActive == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>نمایش در وب سایت   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.Web_IsActive == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} fixed="right" >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >




            <Modal show={ShowModal} backdrop="static" keyboard={false} onHide={() => setShowModal(false)} size="lg"  >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>تعریف برند محصولات  </b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Row>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <rsuite.Row>

                                        </rsuite.Row>
                                        <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>عنوان</label>
                                        <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                                    </rsuite.Col>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <rsuite.Row>

                                        </rsuite.Row>
                                        <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>ترتیب نمایش</label>
                                        <rsuite.Input value={Order} onChange={(e) => setOrder(e)} />
                                    </rsuite.Col>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp; فعال می باشد

                                    </rsuite.Col>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <rsuite.Checkbox onChange={(e, checked) => setWeb_IsActive(checked)} checked={Web_IsActive} value={Web_IsActive} /> &nbsp; در وب سایت فعال می باشد

                                    </rsuite.Col>
                                </rsuite.Row>

                            </rsuite.Col>

                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Row>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='text-center'>
                                        <label htmlFor="upload-button">
                                            {image.preview ? (
                                                <div className=' shadow  bg-white rounded bg-white h-30vh d-flex align-items-center justify-content-center p-5'>

                                                    <img src={image.preview} alt="dummy" width="150" height="150" />
                                                </div>
                                            ) : (

                                                <div className=' shadow  bg-white rounded bg-white h-30vh d-flex align-items-center justify-content-center p-5'>

                                                    <h5 className="text-center fs-6 Cursor">  به منظور انتخاب تصویر (.jpg) کلیک کنید</h5>
                                                </div>
                                            )}
                                        </label>
                                        <input
                                            type="file"
                                            id="upload-button"
                                            style={{ display: "none" }}
                                            onChange={ImageChange}
                                            accept="image/jpg"
                                        />
                                        {/* <br /> */}
                                        {/* <rsuite.button onClick={handleUpload}>Upload</rsuite.button> */}
                                    </rsuite.Col>
                                </rsuite.Row>

                            </rsuite.Col>

                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>



            <Delete ref={DeleteRef} onSubmit={GetAll} />
        </Layout >


    )
}

export default BrandIndex;